var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokerProLucky7Icon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 10.5H35.4375M18.375 10.5C18.375 11.1962 18.0984 11.8639 17.6062 12.3562C17.1139 12.8484 16.4462 13.125 15.75 13.125C15.0538 13.125 14.3861 12.8484 13.8938 12.3562C13.4016 11.8639 13.125 11.1962 13.125 10.5M18.375 10.5C18.375 9.80381 18.0984 9.13613 17.6062 8.64384C17.1139 8.15156 16.4462 7.875 15.75 7.875C15.0538 7.875 14.3861 8.15156 13.8938 8.64384C13.4016 9.13613 13.125 9.80381 13.125 10.5M13.125 10.5H6.5625M18.375 31.5H35.4375M18.375 31.5C18.375 32.1962 18.0984 32.8639 17.6062 33.3562C17.1139 33.8484 16.4462 34.125 15.75 34.125C15.0538 34.125 14.3861 33.8484 13.8938 33.3562C13.4016 32.8639 13.125 32.1962 13.125 31.5M18.375 31.5C18.375 30.8038 18.0984 30.1361 17.6062 29.6438C17.1139 29.1516 16.4462 28.875 15.75 28.875C15.0538 28.875 14.3861 29.1516 13.8938 29.6438C13.4016 30.1361 13.125 30.8038 13.125 31.5M13.125 31.5H6.5625M28.875 21H35.4375M28.875 21C28.875 21.6962 28.5984 22.3639 28.1062 22.8562C27.6139 23.3484 26.9462 23.625 26.25 23.625C25.5538 23.625 24.8861 23.3484 24.3938 22.8562C23.9016 22.3639 23.625 21.6962 23.625 21M28.875 21C28.875 20.3038 28.5984 19.6361 28.1062 19.1438C27.6139 18.6516 26.9462 18.375 26.25 18.375C25.5538 18.375 24.8861 18.6516 24.3938 19.1438C23.9016 19.6361 23.625 20.3038 23.625 21M23.625 21H6.5625",
    stroke: "url(#paint0_linear_6447_27609)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6447_27609",
    x1: 11.3474,
    y1: 18.2727,
    x2: 38.9332,
    y2: 42.1928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokerProLucky7Icon2);
export default __webpack_public_path__ + "static/media/jokerProLucky7Icon2.16f3182e1bdf75eeb39fc4e63fdefa77.svg";
export { ForwardRef as ReactComponent };